import * as yup from "yup";
import { cnpj, cpf } from 'cpf-cnpj-validator';

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

const formSchema = yup.object().shape({
  document: yup.string().required('Campo obrigatório').test('invalid-value', 'Campo inválido', async (value) => {
    const isEmailValid = await yup.string().email().matches(emailRegex).isValid(value);
    console.log({isEmailValid});
    return isEmailValid || cnpj.isValid(value) || cpf.isValid(value);
  })
});

export default formSchema;